/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc) {
	'use strict';
	/**
	 * Skin for rotating teaser theme of the slider.
	 * Implemented as part of the new story project
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module.Slider
	 * @class RotatingTeaser
	 * @extends Tc.Module
	 * @constructor
	 */
	Tc.Module.Slider.RotatingTeaser = function(parent) {

		this.on = function(callback) {
			parent.on.call(this, callback);
		};

		/**
		 * Find the closest sibling slide that is not disabled
		 * and activate that slide instead.
		 * @param $slide
		 */
		this.activateNextEnabledSibling = function($slide){
			var mod = this;
			var siblingVicinity;
			var $sibling;

			$slide.siblings(':not(.disabled)').each(function(index, sibling){
				var vicinity = Math.abs(mod.slides.index($(sibling)) - mod.slides.index($slide));
				if(!siblingVicinity || vicinity < siblingVicinity) {
					siblingVicinity = vicinity;
					$sibling = $(sibling);
				}
			});

			if($sibling && $sibling.length){
				mod.gotoSlideWithId($sibling.data('id'));
			}
			else {
				// disable whole slider
			}
		};

		this.after = function(){
			var delayTime = this.isMobile ? 1500 : 150;

			setTimeout($.proxy( this.setSliderHeight, this), delayTime);

			if(this.isMobile){
				$(window).on('load', $.proxy(this.setSliderHeight, this));
			}
		};

		this.initSlider = function () {
			this.controlsEnabled = this.isMobile;
			this.$ctx.toggleClass('no-controls', !this.controlsEnabled);

			var options = {
				pause: (this.animationInterval * 1000),
				speed: 240,
				startSlide: this.startIndex,
				infiniteLoop: this.loopAround,
				auto: (this.animationInterval > 0),
				preloadImages: 'visible',
				hideControlOnEnd: false,
				nextText: '',
				prevText: '',
				touchEnabled: this.isMobile,
				swipeThreshold: 50,
				useCSS: false, // has to be off, bx slider can not handle end-off animation in transitions, which will break the slider
				responsive: true,
				adaptiveHeight: false,
				onSlideBefore: $.proxy(this.handleBeforeSlide, this),
				onSlideAfter: this.handleAfterSlide.bind(this),
				onSliderLoad: $.proxy(this.cleanupSliderOnLoad, this),
				slideWidth: this.isMobile ? 280 : 300
			};

			if(this.deepLinking && this.sliderId) {
				options.onSlideAfter = $.proxy(this.setDeepLink, this);
			}

			this.slider = $('ul.bx-slider', this.$ctx).bxSlider(options);

			// Fix width 100% -> 100px problem
			if(this.slider.getCurrentSlideElement().width() < options.slideWidth){
				this.slider.children().css('width', options.slideWidth);

				// Fix slider position
				this.slider.css('left', -(options.startSlide*options.slideWidth));
			}
		};

		this.handleAfterSlide = function($slideElement) {
			if($slideElement.hasClass('disabled') && $slideElement.hasClass('active')) {
				this.activateNextEnabledSibling($slideElement);
			}
		}

		this.handleBeforeSlide = function($slideElement) {
			var activeSlideIndex = $slideElement.index();
			var $slideContent = $slideElement.find('.slideContent');
			var paddingTotal = parseInt($slideContent.css('padding-left'), 10) + parseInt($slideContent.css('padding-right'), 10);


			this.slides.removeClass('active leftOfActive');
			$slideElement.addClass('active');

			$.each(this.slides, function(index, slide){
				var $slide = $(slide);
				var slideIndex = $slide.index();
				var stepsAway = (activeSlideIndex >= slideIndex) ? (activeSlideIndex - slideIndex) : (activeSlideIndex + 1 - slideIndex);

				$slide.find('.slideContent').css('margin-left', stepsAway * paddingTotal);
			});

			parent.handleBeforeSlide.call(this, $slideElement);
		};

		this.handleSlideClicked = function(event){
			var $slide = $(event.currentTarget);

			if(!$slide.hasClass('disabled')) {
				var slideIndex = this.slides.index($slide);
				this.slider.goToSlide(slideIndex);
			}
		};

		this.showHideControl = $.noop;

		this.cleanupSliderOnLoad = function () {
			var mod = this;
			// enable transitions
			mod.$ctx.find('.bx-viewport').addClass('cf').prop('style', '');
			mod.lazyLoadFirstItem();
			mod.$ctx.removeClass('not-initialized');
			setTimeout(function(){
				mod.$ctx.addClass('transitionsEnabled');
			}, 0);
		};

		this.addEventListeners = function(){
			this.enable();
			parent.addEventListeners.call(this);
		};

		this.disable = function() {
			this.slides.off('click', $.proxy(this.handleSlideClicked, this));
			this.$ctx.addClass('disabled');
		};

		this.enable = function() {
			if(!this.isMobile){
				this.slides.on('click', $.proxy(this.handleSlideClicked, this));
			}
			this.$ctx.removeClass('disabled');
		};

		this.setSliderHeight = function(){
			var biggestSlideHeight = 0;

			this.slides.each(function(index, slide){
				var $slide = $(slide);
				var $slideContent = $slide.find('.slideContent');

				biggestSlideHeight = Math.max($slideContent.height(), biggestSlideHeight);
			});

			this.slides.find('.slideContent').css('min-height', biggestSlideHeight);

			// set the height of the viewport, so the controls wont move around when changing slides.
			this.$ctx.find('.bx-wrapper').css('height', biggestSlideHeight);
			this.$ctx.css('height', biggestSlideHeight);
		};

		// fired by Tc.Module.LegoContainer
		this.onSliderToggleEnable = function(data) {
			if (this.sliderId === data.sliderId) {
				if (data.enable) {
					this.enable();
				}
				else {
					this.disable();
				}
			}
		};

		/**
		 * Message handler to enable/disable individual slides.
		 * @param data
		 */
		this.onSetSlideState = function(data) {
			var $slide = this.slides.filter('[data-id='+data.slideId+']');

			if(!$slide.length || !this.componentInitialized || ($slide.hasClass('disabled') && data.disable === true)) {
				return;
			}

			$slide.toggleClass('disabled', data.disable);
			// if this is the currently active slide, that we are disabling
			// it can't stay active anymore.
			if($slide.hasClass('active') && data.disable === true) {
				this.activateNextEnabledSibling($slide);
			}
		};
	};
})(window.Tc.$, window.Tc);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.Slider.RotatingTeaser.js
// module id = 92
// module chunks = 0